
export const DOMAIN_INVALID_CHARS = /[^a-z0-9.\-]+/;
export const DOMAIN_HYPHEN_OPENING_TRAILING = /(^[-]+|[.][-]|[-][.]|[a-z0-9-][-]$)/;
export const DOMAIN_STRUCTURE = /^([^.\s]+[.]){1,3}[a-z0-9-]+$/;
export const SUBDOMAIN_STRUCTURE = /^([^.\s]+[.]){2,4}[a-z0-9-]+$/;
export const DOMAIN_EXTRA_CHARS = /^([a-z0-9]+(([\-][a-z0-9]+)+)?\.){1,3}[a-z0-9-]+$/;
export const SUBDOMAIN_EXTRA_CHARS = /^([a-z0-9]+(([\-][a-z0-9]+)+)?\.){2,4}[a-z0-9-]+$/;